/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface GetMriRiskResponse
 */
export interface GetMriRiskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetMriRiskResponse
     */
    type: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetMriRiskResponse
     */
    person?: PersonDto;
    /**
     * Id of the coproperty linked to the MRI risk (null until selected)
     * @type {string}
     * @memberof GetMriRiskResponse
     */
    copropertyId?: string | null;
    /**
     * 
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetMriRiskResponse
     */
    surveyAnswers?: Array<QuestionAnswerDto>;
}

/**
 * Check if a given object implements the GetMriRiskResponse interface.
 */
export function instanceOfGetMriRiskResponse(value: object): value is GetMriRiskResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetMriRiskResponseFromJSON(json: any): GetMriRiskResponse {
    return GetMriRiskResponseFromJSONTyped(json, false);
}

export function GetMriRiskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMriRiskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'person': json['person'] == null ? undefined : PersonDtoFromJSON(json['person']),
        'copropertyId': json['copropertyId'] == null ? undefined : json['copropertyId'],
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
    };
}

export function GetMriRiskResponseToJSON(json: any): GetMriRiskResponse {
    return GetMriRiskResponseToJSONTyped(json, false);
}

export function GetMriRiskResponseToJSONTyped(value?: GetMriRiskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'person': PersonDtoToJSON(value['person']),
        'copropertyId': value['copropertyId'],
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
    };
}

